import * as Prism from 'prismjs';
import { useEffect, useMemo, useRef, useState } from 'react';
import './prism-languages';
import { styled } from '@mui/material/styles';
import clsx from 'clsx';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { Tooltip } from '@mui/material';

const styledProps = {
  display: 'flex',
  width: '100%',
  height: '38rem',
  position: 'relative',
  flexWrap: 'wrap',
  overflowY: 'scroll',
  justifyContent: 'flex-start',
  whiteSpace: 'pre-wrap',
  alignItems: 'flex-start',
  padding: '2rem 0.5em 0.5em 2rem',
  background: '#272822',
  color: '#ddd',
  scrollbarWidth: 'thin',
  scrollbarColor: '#90A4AE #CFD8DC',
};

export const SnippetCopier = styled(
  ({ async, children = '', className, component: Wrapper = 'code' }) => {
    const domNode = useRef(null);
    const [copied, setCopied] = useState(false);

    useEffect(() => {
      if (domNode.current) {
        Prism.highlightAll(domNode.current, async);
      }
    }, [children, async]);

    const handleCopy = () => {
      const text = domNode.current?.textContent || '';
      navigator.clipboard.writeText(text).then(() => {
        setCopied(true);
        setTimeout(() => setCopied(false), 1500);
      });
    };

    return useMemo(() => {
      return (
        <div
          style={{
            position: 'relative',
            width: '100%',
            paddingBottom: '2rem',
            marginBottom: '2rem',
          }}
        >
          <Tooltip title={copied ? 'Copied!' : 'Copy'}>
            <ContentCopyIcon
              onClick={handleCopy}
              style={{ position: 'absolute', top: 8, right: 8, zIndex: 1, color: '#fff' }}
              size="small"
            >
              <ContentCopyIcon fontSize="small" />
            </ContentCopyIcon>
          </Tooltip>
          <Wrapper ref={domNode} className={clsx('border', className)}>
            {children}
          </Wrapper>
        </div>
      );
    }, [children, className, copied]);
  }
)(({ theme }) => styledProps);
